<template>
	<ts-loading-banner :loading="loading">
		<ts-card>
			<div class="form-header ts-bg-gray-100 ts-border-b ts-border-gray-400 ts-p-4 ts-relative">
				<h4 class="ts-text-sm">
					{{ $t('administration.employee.employeeProfile.transfer') }}
				</h4>
			</div>
			<ts-card-wrapper>
				<form>
					<div class="col-md-12">
						<label>{{ $t('administration.employee.employeeProfile.fromBranch') }}
						</label>
						<a-select v-model="model.from_branch_id" :options="branches" :disabled="true"></a-select>
					</div>
					<div class="col-md-12 ts-mt-3">
						<label class="required">{{ $t('administration.employee.employeeProfile.toBranch') }}
						</label>
						<a-select v-model="model.to_branch_id" :options="branches"></a-select>
						<div class="validate" v-if="errors.has('to_branch_id')">
							{{ errors.first('to_branch_id') }}
						</div>
					</div>
					<div class="col-md-12 ts-mt-3">
						<label class="required">{{ $t('administration.employee.employeeProfile.reason') }}
						</label>
						<textarea rows="3" class="form-control" v-model="model.reason"></textarea>
						<div class="validate" v-if="errors.has('reason')">
							{{ errors.first('reason') }}
						</div>
					</div>
					<div class="col-md-12 text-right ts-mt-4">
						<ts-button @click.prevent="$emit('close')" :disabled="waiting" class="ts-mr-3">
							{{ $t('cancel') }}
						</ts-button>
						<ts-button color="primary" :waiting="waiting" @click.prevent="transfer">
							{{ $t('Transfer') }}
						</ts-button>
					</div>
				</form>
			</ts-card-wrapper>
		</ts-card>
	</ts-loading-banner>
</template>
  
<script>

import { Errors } from 'form-backend-validation'

export default {
	name: 'transfer-form',
	props: ['value'],
	data() {
		return {
			waiting: false,
			loading: false,
			errors: new Errors(),
			branches: [],
			model: {
				from_branch_id: '',
				to_branch_id: '',
				employee_id: null,
				reason: null
			}
		}
	},
	created() {
		this.Getbranch();
	},
	methods: {
		Getbranch() {
			this.loading = true
			this.$store.dispatch('employee/Getbranch')
				.then(response => {
					this.branches = response.map(el => ({
						value: el.branch_id,
						label: el.branch_name_en
					}))

					// set value to model
					this.model.employee_id = this.value.staff_id
					this.model.from_branch_id = this.value.branch_id
				})
				.finally(() => this.loading = false)
		},
		transfer() {
			this.errors = new Errors()
			this.waiting = true
			this.$store
				.dispatch('employee/transferBranch', this.model)
				.then((response) => {
					this.$toasted.success(response.message)
					this.$emit('close')
				})
				.catch((error) => {
					this.waiting = false
					this.$toasted.error(error.message)
					this.errors = new Errors(error.errors)
				})
				.finally(() => this.waiting = false)
		},
	},
}
</script>